import { AuthenticationError, AuthorizationError, Back4app2Error, NetworkError, User } from '@back4app2/sdk';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import back4app2 from './back4app2';
import { BACK4APP_DOT_COM_SITE_URL, EMAIL_VERIFICATION_REDIRECT_URL } from './settings';
import { Toaster } from 'react-hot-toast';
// import { ReactComponent as StatusErrorSVG } from './assets/images/status-error.svg';
import { initializeAmplitude, setUserForTracking } from './utils/amplitude';
// import { setUser as setSentryUser } from '@sentry/react';

function App() {
  const [user, setUser] = useState<User>();
  // const { isReconnecting } = useBack4app2ConnectionStatus();

  useEffect(() => {
    (async () => {
      let user;

      try {
        user = await back4app2.me();
        const fetchedUser = user;
        // Dynamically import Sentry to avoid bundling it in main chunk
        import('@sentry/react').then(({ setUser: setSentryUser }) => {
          setSentryUser({
            id: fetchedUser.username,
            email: fetchedUser.username,
            username: fetchedUser.username,
            ip_address: "{{auto}}",
          });
        });
        initializeAmplitude(user.username);
        setUserForTracking(user.id, user.username);
      } catch (e) {
        if (e instanceof NetworkError) {
          console.error('network error when getting user', e);
        } else if (e instanceof AuthenticationError || e instanceof AuthorizationError) {
          console.error('authentication or authorization error when getting user', e);
        } else if (e instanceof Back4app2Error && e.code === 'NOT_CONTAINERS_BETA_USER') {
          console.error('not a containers beta user', e);
          window.location.replace(BACK4APP_DOT_COM_SITE_URL);

          return;
        } else {
          console.error('unexpected error when getting user', e);
        }

        window.location.replace(`${BACK4APP_DOT_COM_SITE_URL}/login?return-url=${encodeURIComponent(window.location.href)}`);

        return;
      };

      // New (post-cutoff) users must confirm their email before entering the
      // dashboard. Bounce to the verify page and abort so the shell never
      // renders. Existing users have requiresEmailVerification === false.
      if (user && user.requiresEmailVerification) {
        window.location.replace(`${EMAIL_VERIFICATION_REDIRECT_URL}?dest=${encodeURIComponent(window.location.href)}`);

        return;
      }

      setUser(user);
    })();
  }, []);

  // useEffect(() => {
  //   if (isReconnecting) {
  //     const toastId = toast.error('Cannot connect to our servers. Please check your internet. Reconnecting...', {
  //       className:"bg-white px-6 py-4 text-dark text-center rounded-none rounded-tl-lg rounded-tr-lg shadow-[0_6px_16px_rgba(0,0,0,0.25)] text-sm",
  //       icon: <StatusErrorSVG width="24px" height="24px" className="animate-bounce-in flex-none" />,
  //       duration: Infinity,
  //       position: 'bottom-center',
  //     });

  //     return () => {
  //       toast.dismiss(toastId);
  //     };
  //   }
    
  // }, [isReconnecting]);

  return (<>
    <div className="w-full h-full flex flex-col overflow-hidden">
      <Outlet context={{ user }} />
      <div
        className="absolute -left-[16.5625rem] -top-[9.5625rem] lg:-top-[23.4375rem] w-[36.8125rem] lg:w-[50.125rem] h-[34.6875rem] lg:h-[47.25rem] rounded-[374px] opacity-30 -z-[1]"
        style={{
          background: 'radial-gradient(48.2% 50% at 50% 50%, #3496EF 0%, rgba(15, 28, 50, 0) 100%)'
        }}
      >        
      </div>
      <Toaster />
    </div>    
  </>);
}

export default App;